import React from 'react';

import {TitleLogo} from './styled';

export const TitleLogoComponent = () => <TitleLogo src={'/logo/Logo_TC_login.webp'} alt="Logo" />;
